import { React,useState } from 'react';
import { Offcanvas } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"

export default function MenuClient() {
	const { t } = useTranslation()
    const [show, setShow] = useState(false)
    const handleClose = () =>  setShow(false)
    const handleShow = () => setShow(true)
	const {logout} = useAuth()
  	return (
		<header>
			<div id="avatar" onClick={handleShow} className="d-flex justify-content-center align-items-center">
				<figure className="d-flex justify-content-center align-items-center">
					<i className="fa-solid fa-user fa-2x"></i>
				</figure>
			</div>
			<Offcanvas show={show} onHide={()=>setShow(false)} placement="end">
				<Offcanvas.Header closeButton>
				<Offcanvas.Title className='text-uppercase'><strong>{t('global.menu')}</strong></Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body id='menu'>
					<ul className="list-group">
						<Link to="/client/dashboard" onClick={handleClose}>
							<li className="list-group-item">
								{t('global.home')}							
							</li>
						</Link>						
						<Link to="/client/takerestaurant" onClick={handleClose}>
							<li className="list-group-item">
								{t('client.dashboard.takeorder')}
							</li>
						</Link>
						<Link to="/client/pendingorders" onClick={handleClose}>
							<li className="list-group-item">
								{t('client.dashboard.pendingorder')}
							</li>
						</Link>
						<Link to="/client/completedorders" onClick={handleClose}>
							<li className="list-group-item">
								{t('client.dashboard.completedorder')}
							</li>
						</Link>
						<Link to="/client/config" onClick={handleClose}>
							<li className="list-group-item">
								{t('global.perfil')}
							</li>
						</Link>
						<Link to="/#" onClick={logout}>
							<li className="list-group-item">
								{t('global.logout')}
							</li>
						</Link>						
					</ul>
				</Offcanvas.Body>
			</Offcanvas>
		</header>
	)
}